// extracted by mini-css-extract-plugin
export default {"wrapper":"Section_wrapper__ooH2o","header":"Section_header__8VMAW","content":"Section_content__AA6Za"};